export var slice=Array.prototype.slice;export default function(x){return"object"==typeof x&&"length"in x?x:Array.from(x)}